import { createSlice } from "@reduxjs/toolkit";
import liveAuth from "src/helper/liveAuth";
import System from "src/helper/system";
import Constants from 'src/helper/Constants';
const { siteUser } = Constants
const isInternalUser = System.validateDomain(liveAuth.getAvUserInfo()?.email)
const isCoreUser = System.avUserInfoData.currentUser === siteUser.CORE
const slice = createSlice({
    name: "BOM__BOMDownloadPopup",
    initialState: {
        selected_fields: {},
        save_preference: false,
        export_type: '',
    },
    reducers: {
        load_all_selected_fields: {
            reducer: (state, action) => {
                if (!isCoreUser) {
                    const { customerPartNumber, ...newObj } = action.payload.selected_fields;
                    action.payload.selected_fields = newObj;
                }
                if (!isInternalUser) {
                    const { designRegisterable, ...newObj } = action.payload.selected_fields;
                    action.payload.selected_fields = newObj;
                }

                state.selected_fields = action.payload.selected_fields;
            },
        },
        load_initialState: {
            reducer: (state, action) => {
                state = action.payload;
                if (action.payload.selected_fields === undefined) {
                    state.selected_fields = {};
                }
                if (action.payload.export_type === undefined) {
                    state.export_type = '';
                }
                if (action.payload.save_preference === undefined) {
                    state.save_preference = '';
                }
                state.save_preference = false;
                return state;
            },
        },
        export_type: {
            reducer: (state, action) => {
                state.export_type = action.payload.export_type;
            },
        },
        save_preference: {
            reducer: (state, action) => {
                if (state.save_preference) {
                    state.save_preference = '';
                } else {
                    state.save_preference = action.payload.save_preference;
                }
            },
        },
        remove_all_selected_fields: {
            reducer: (state, action) => {
                state.selected_fields = {};
            },
        },
        toggle_single_selected_fields: {
            reducer: (state, action) => {
                if (state.selected_fields[action.payload.columnName] !== undefined) {
                    delete state.selected_fields[action.payload.columnName];
                } else {
                    if (state.selected_fields[action.payload.columnName] === undefined) {
                        state.selected_fields[action.payload.columnName] = action.payload;
                    }
                }
            },
        },
    }
})
    ;

export let {
    export_type,
    save_preference,
    load_all_selected_fields,
    remove_all_selected_fields,
    toggle_single_selected_fields,
    load_initialState
} = slice.actions;

export default slice.reducer;
